module.exports = __webpack_public_path__ + "assets/img/active_community_l3-2.cc4f0993.png";